<template>
	<div class="container-fluid">
		<CLoader :pConfigLoad="ConfigLoadGral">
			<template slot="BodyFormLoad">
				<Clist :regresar="Regresar"
        :Nombre="Titulo"
        @FiltrarC="Lista"
        :Filtro="Filtro"
        :isModal="EsModal"
        :pShowBtnAdd="false"
        :pConfigLoad="ConfigLoad"
        :isHistorialEquipo="true"
        :ShowPager="ShowPager"
        :ShowFilas="false"
        :ShowBusqueda="false">
			<template slot="DatosEquipo">
				<div class="col-lg-12 mb-3">
					<div class="row">
						<div class="col-lg-2">
							<div class="avatar-upload-histequipo">
                                <div class="avatar-edit">
									<input id="ficha" @change="CambiarImagenVehiculo($event)" ref="ficha" type="file" name="ficha" accept=".png, .jpg, .jpeg">
									<label for="ficha"></label>
								</div>
                                <div v-if="BndImagenVehiculo!=0" class="avatar-edit3">
									<button type="button" @click="GuardarImagenVehiculo">
										<i class="fas fa-save"></i>
									</button>
								</div>
                                <div class="avatar-preview">
									<div id="imagePreviewFicha" :style="'background-image: url('+Vehiculo.Foto+');'" :src="Vehiculo.Foto">
									</div>
								</div>
                            </div>
                            <div v-if="BndImagenVehiculo!=0">
								<p class="text-danger text-leyenda">Aún no sube la imagen, presione guardar para subirla</p>
							</div>
						</div>
						<div class="col-lg-2">
							<span class="titulosflota">Descripción: </span> <span class="text-info titulosflota">{{ Vehiculo.Categoria }}</span>
							<br>
							<span class="titulosflota">Placa: </span> <span class="text-info titulosflota">{{ Vehiculo.Placa }}</span>
							<br>
							<span class="titulosflota">Modelo: </span> <span class="text-info titulosflota">{{ Vehiculo.Modelo }}</span>
							<br>
							<span class="titulosflota">Marca: </span> <span class="text-info titulosflota">{{ Vehiculo.Marca }}</span>
							<br>
							<span class="titulosflota">Número: </span> <span class="text-info titulosflota">{{ Vehiculo.Numero }}</span>
							<br>
							<span class="titulosflota">Año: </span> <span class="text-info titulosflota">{{ Vehiculo.Ano }}</span>
							<br>
							<span class="titulosflota">Tipo de Cobro: </span> <span class="text-info titulosflota">{{ Vehiculo.TipoVehiculo }}</span>
							<br>
							<span class="titulosflota">Costo: </span> <span class="text-info titulosflota">$ {{ formateoMillon(parseInt(Vehiculo.CostoAnual)) }}</span>
						</div>
						<div class="col-lg-1 p-0">
							<label>Año</label>
							<select @change="GetVehiculo" v-model="Anio" class="form-control ml-2">
								<option value="">Todos</option>
								<option v-for="(item,index) in ListaAnios" :value="item" :key="index">{{item}}</option>
							</select>
							<label class="ml-2 mt-3">Mes</label>
							<select @change="GetVehiculo" v-model="Mes" class="form-control ml-2">
								<option value="">Todos</option>
								<option value="1">Enero</option>
								<option value="2">Febrero</option>
								<option value="3">Marzo</option>
								<option value="4">Abril</option>
								<option value="5">Mayo</option>
								<option value="6">Junio</option>
								<option value="7">Julio</option>
								<option value="8">Agosto</option>
								<option value="9">Septiembre</option>
								<option value="10">Octubre</option>
								<option value="11">Noviembre</option>
								<option value="12">Diciembre</option>
							</select>
						</div>
						<div style="width:3% !important;"></div>
						<div class="col-lg-5">
							<div class="row">
								<div class="col-lg-4" style="flex-basis:30%">
									<h2 class="bold">Km. Reales:</h2> 
								</div>
								<div class="col-lg-2 p-0">
									<h2 class="text-info bold">{{ formateoMillon(parseInt(Vehiculo.KmReales)) }}</h2>
								</div>
								<div class="col-lg-3">
									<h2 class="bold">Combustible:</h2> 
								</div>
								<div class="col-lg-3 p-0">
									<h2 class="text-info bold">$ {{ formateoMillon(parseInt(Vehiculo.Combustible)) }}</h2>
								</div>
							</div>
							<div class="row mt-2">
								<div class="col-lg-4 pr-0" style="flex-basis:30%">
									<h2 class="bold">Km. Despachados:</h2>
								</div>
								<div class="col-lg-2 p-0">
									<h2 class="text-info bold">{{formateoMillon(parseInt(Vehiculo.KmRecorridos))}}</h2>
								</div>
								<div class="col-lg-3">
									<h2 class="bold">Mant. Total:</h2> 
								</div>
								<div class="col-lg-3 p-0">
									<h2 class="text-info bold">$ {{ formateoMillon(parseInt(Vehiculo.MantenimientoTotal)) }}</h2>
								</div>
							</div>
							<div class="row mt-2">
								<div class="col-lg-4" style="flex-basis:30%">
									<h2 class="bold">Km. Productivos:</h2> 
								</div>
								<div class="col-lg-2 p-0">
									<h2 class="text-info bold">{{ formateoMillon(parseInt(Vehiculo.KmProductivos)) }}</h2>
								</div>
							</div>
                        </div>
						<div class="col-lg-2" style="flex-basis:13%">
                            <div class="d-flex justify-content-end">
                                <button class="btn btn-01 mr-2" @click="EditarVehiculo(Vehiculo.IdVehiculo)" data-toggle="modal" data-target="#ModalForm">Editar</button>
                                <button class="btn btn-danger" @click="BorrarVehiculo(Vehiculo.IdVehiculo)">Eliminar</button>
                            </div>
                        </div>
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div class="form-inline">
								<button @click="CambiarPestania('Kilometraje')" type="button" :class="Botones.Kilometraje ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Odómetro</button>
								<button @click="CambiarPestania('Depreciacion')" type="button" :class="Botones.Depreciacion ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">D&A / leasing</button>
								<button @click="CambiarPestania('Combustible')" type="button" :class="Botones.Combustible ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Combustible</button>
								<button @click="CambiarPestania('Mantenimiento')" type="button" :class="Botones.Mantenimiento ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Mantenimiento</button>
								<button @click="CambiarPestania('Reparacion')" type="button" :class="Botones.Reparacion ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Reparaciones</button>
								<button @click="CambiarPestania('Refacciones')" type="button" :class="Botones.Refacciones ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Refacciones</button>
								<button @click="CambiarPestania('Permisos')" type="button" :class="Botones.Permisos ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Permisos / Lic.</button>
								<button @click="CambiarPestania('Seguros')" type="button" :class="Botones.Seguros ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Seguros</button>
								<button @click="CambiarPestania('Siniestros')" type="button" :class="Botones.Siniestros ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Siniestro</button>								
								<button @click="CambiarPestania('Herramienta')" type="button" :class="Botones.Herramienta ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Herramientas</button>
								<button @click="CambiarPestania('Observacion')" type="button" :class="Botones.Observacion ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Observaciones</button>
								<!-- <button @click="CambiarPestania('Stock')" type="button" :class="Botones.Stock ? 'btn btn-06 text-info bold m-0 pb-0 pr-2 pt-2' : 'btn btn-06 text-dark bold m-0 pb-0 pr-2 pt-2'">Stock</button> -->
								<button disabled type="button" class="btn btn-06 text-gray-300 bold m-0 pb-0 pr-2 pt-2">Stock</button>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-if="Botones.Kilometraje" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Odómetro</th>
					<!-- <th>Kilometraje</th> -->
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoKilometraje()" type="button" data-toggle="modal" data-target="#Kilometraje" class="btn-obs"><i class="fa fa-plus" title="Agregar Registro de Kilometraje"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Kilometraje" slot="body">
				<tr v-for="(item,index) in ListVehiculoKilometraje" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>{{ formateoMillon(parseFloat(item.Horometro)) + ' Km' }}</td>
					<!-- <td>{{ formateoMillon(parseFloat(item.HorometroFin)-parseFloat(item.HorometroInicio)) + ' Km' }}</td> -->
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalKilometraje.EmitSeccion" 
                        :Id="item.IdVehiculoKilometraje"
                        :IrA="ConfigModalKilometraje.Nombre">
                            <!-- <template slot="btnaccion">
                                <button @click="AbrirDocumento(item.Archivo)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template> -->
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoKilometraje.length" :pColspan="9"></CSinRegistros>
			</template>
			<template v-if="Botones.Combustible" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Valor</th>
					<th>Proveedor</th>
					<th>Número de Cuenta</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoCombustible()" type="button" data-toggle="modal" data-target="#Combustible" class="btn-obs"><i class="fa fa-plus" title="Agregar Registro de Combustible"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Combustible" slot="body">
				<tr v-for="(item,index) in ListVehiculoCombustible" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>$ {{ formateoMillon(parseFloat(item.Valor)) }}</td>
					<td>{{item.Proveedor==null ? '-' : item.Proveedor}}</td>
					<td>{{item.NumeroCuenta==null ? '-' : item.NumeroCuenta}}</td>
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalCombustible.EmitSeccion" 
                        :Id="item.IdVehiculoCombustible"
                        :IrA="ConfigModalCombustible.Nombre">
                            <template slot="btnaccion">
                                <button v-show="item.ArchivoFactura!=null" @click="AbrirDocumento(RutaPdfCombustible+item.ArchivoFactura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
								<button v-show="item.ArchivoFactura==null" @click="AbrirDocumento(RutaPdfCuenta+item.Factura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoCombustible.length" :pColspan="7"></CSinRegistros>
			</template>

			<template v-if="Botones.Seguros" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Valor</th>
					<th>Proveedor</th>
					<th>Número de Cuenta</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoSeguro()" type="button" data-toggle="modal" data-target="#Seguro" class="btn-obs"><i class="fa fa-plus" title="Agregar Registro de Seguro"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Seguros" slot="body">
				<tr v-for="(item,index) in ListVehiculoSeguro" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>$ {{ formateoMillon(parseFloat(item.Valor)) }}</td>
					<td>{{item.Proveedor==null ? '-' : item.Proveedor}}</td>
					<td>{{item.NumeroCuenta==null ? '-' : item.NumeroCuenta}}</td>
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalSeguro.EmitSeccion" 
                        :Id="item.IdVehiculoSeguro"
                        :IrA="ConfigModalSeguro.Nombre">
                            <template slot="btnaccion">
                                <button v-show="item.ArchivoFactura!=null" @click="AbrirDocumento(RutaPdfSeguro+item.ArchivoFactura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
								<button v-show="item.ArchivoFactura==null" @click="AbrirDocumento(RutaPdfCuenta+item.Factura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoSeguro.length" :pColspan="7"></CSinRegistros>
			</template>
			<template v-if="Botones.Siniestros" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Tipo</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoSiniestro()" type="button" data-toggle="modal" data-target="#Siniestro" class="btn-obs"><i class="fa fa-plus" title="Agregar Registro de Siniestro"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Siniestros" slot="body">
				<tr v-for="(item,index) in ListVehiculoSiniestro" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>{{ EvalSiniestroSeguro(item.Tipo) }}</td>
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalSiniestro.EmitSeccion" 
                        :Id="item.IdVehiculoSiniestro"
                        :IrA="ConfigModalSiniestro.Nombre">
                            <template slot="btnaccion">
                                <button @click="AbrirDocumento(RutaPdfSiniestro+item.Archivo)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoSiniestro.length" :pColspan="5"></CSinRegistros>
			</template>
			<template v-if="Botones.Mantenimiento" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Valor</th>
					<th>Proveedor</th>
					<th>Número de Cuenta</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoMantenimiento()" type="button" data-toggle="modal" data-target="#Mantenimiento" class="btn-obs"><i class="fa fa-plus" title="Agregar Registro de Mantenimiento"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Mantenimiento" slot="body">
				<tr v-for="(item,index) in ListVehiculoMantenimiento" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>$ {{ formateoMillon(parseFloat(item.Valor)) }}</td>
					<td>{{item.Proveedor==null ? '-' : item.Proveedor}}</td>
					<td>{{item.NumeroCuenta==null ? '-' : item.NumeroCuenta}}</td>
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalMantenimiento.EmitSeccion" 
                        :Id="item.IdVehiculoMantenimiento"
                        :IrA="ConfigModalMantenimiento.Nombre">
                            <template slot="btnaccion">
                                <button v-show="item.ArchivoFactura!=null" @click="AbrirDocumento(RutaPdfMantenimiento+item.ArchivoFactura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
								<button v-show="item.ArchivoFactura==null" @click="AbrirDocumento(RutaPdfCuenta+item.Factura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoMantenimiento.length" :pColspan="7"></CSinRegistros>
			</template>
			<template v-if="Botones.Herramienta" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Nombre</th>
					<th>Valor</th>
					<th>Fecha de Renovación</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoHerramienta()" type="button" data-toggle="modal" data-target="#Herramienta" class="btn-obs"><i class="fa fa-plus" title="Agregar Herramienta"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Herramienta" slot="body">
				<tr v-for="(item,index) in ListVehiculoHerramienta" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>{{item.Nombre}}</td>
					<td>$ {{ formateoMillon(parseFloat(item.Valor)) }}</td>
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.FechaRenovacion,false) }}</td>
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalHerramienta.EmitSeccion" 
                        :Id="item.IdVehiculoHerramienta"
                        :IrA="ConfigModalHerramienta.Nombre">
                            <!-- <template slot="btnaccion">
                                <button @click="AbrirDocumento(item.Archivo)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template> -->
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoHerramienta.length" :pColspan="7"></CSinRegistros>
			</template>
			<template v-if="Botones.Permisos" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Valor</th>
					<th>Proveedor</th>
					<th>Número de Cuenta</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoPermiso()" type="button" data-toggle="modal" data-target="#Permiso" class="btn-obs"><i class="fa fa-plus" title="Agregar Permiso"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Permisos" slot="body">
				<tr v-for="(item,index) in ListVehiculoPermiso" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>$ {{ formateoMillon(parseFloat(item.Valor)) }}</td>
					<td>{{item.Proveedor==null ? '-' : item.Proveedor}}</td>
					<td>{{item.NumeroCuenta==null ? '-' : item.NumeroCuenta}}</td>
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalPermiso.EmitSeccion" 
                        :Id="item.IdVehiculoPermiso"
                        :IrA="ConfigModalPermiso.Nombre">
                            <template slot="btnaccion">
                                <button v-show="item.ArchivoFactura!=null" @click="AbrirDocumento(RutaPdfPermiso+item.ArchivoFactura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
								<button v-show="item.ArchivoFactura==null" @click="AbrirDocumento(RutaPdfCuenta+item.Factura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoPermiso.length" :pColspan="7"></CSinRegistros>
			</template>
			<template v-if="Botones.Refacciones" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Valor</th>
					<th>Proveedor</th>
					<th>Número de Cuenta</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoRefaccion()" type="button" data-toggle="modal" data-target="#Refaccion" class="btn-obs"><i class="fa fa-plus" title="Agregar Refacción"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Refacciones" slot="body">
				<tr v-for="(item,index) in ListVehiculoRefacciones" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>${{ formateoMillon(parseFloat(item.Valor)) }}</td>
					<td>{{item.Proveedor==null ? '-' : item.Proveedor}}</td>
					<td>{{item.NumeroCuenta==null ? '-' : item.NumeroCuenta}}</td>
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalRefaccion.EmitSeccion" 
                        :Id="item.IdVehiculoRefaccion"
                        :IrA="ConfigModalRefaccion.Nombre">
                            <template slot="btnaccion">
                                <button v-show="item.ArchivoFactura!=null" @click="AbrirDocumento(RutaPdfRefaccion+item.ArchivoFactura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
								<button v-show="item.ArchivoFactura==null" @click="AbrirDocumento(RutaPdfCuenta+item.Factura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoRefacciones.length" :pColspan="7"></CSinRegistros>
			</template>
			<template v-if="Botones.Reparacion" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Valor</th>
					<th>Proveedor</th>
					<th>Número de Cuenta</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoReparacion()" type="button" data-toggle="modal" data-target="#Reparacion" class="btn-obs"><i class="fa fa-plus" title="Agregar Reparación"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Reparacion" slot="body">
				<tr v-for="(item,index) in ListVehiculoReparaciones" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>${{ formateoMillon(parseFloat(item.Valor)) }}</td>
					<td>{{item.Proveedor==null ? '-' : item.Proveedor}}</td>
					<td>{{item.NumeroCuenta==null ? '-' : item.NumeroCuenta}}</td>
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalReparacion.EmitSeccion" 
                        :Id="item.IdVehiculoReparacion"
                        :IrA="ConfigModalReparacion.Nombre">
                            <template slot="btnaccion">
                                <button v-show="item.ArchivoFactura!=null" @click="AbrirDocumento(RutaPdfReparacion+item.ArchivoFactura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
								<button v-show="item.ArchivoFactura==null" @click="AbrirDocumento(RutaPdfCuenta+item.Factura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoReparaciones.length" :pColspan="7"></CSinRegistros>
			</template>
			<template v-if="Botones.Depreciacion" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Valor</th>
					<th>Proveedor</th>
					<th>Numero de Cuenta</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoDepreciacion()" type="button" data-toggle="modal" data-target="#Depreciacion" class="btn-obs"><i class="fa fa-plus" title="Agregar Depreciacion"></i></button>
                    </th>
				</tr>
			</template>
			<template v-if="Botones.Depreciacion" slot="body">
				<tr v-for="(item,index) in ListVehiculoDepreciacion" :key="index">
					<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha,false) }}</td>
                    <td>${{ formateoMillon(parseFloat(item.Valor)) }}</td>
					<td>{{item.Proveedor==null ? '-' : item.Proveedor}}</td>
					<td>{{item.NumeroCuenta==null ? '-' : item.NumeroCuenta}}</td>
                    <td>{{ item.Observaciones }}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalDepreciacion.EmitSeccion" 
                        :Id="item.IdVehiculoDepreciacion"
                        :IrA="ConfigModalDepreciacion.Nombre">
                            <template slot="btnaccion">
                                <button v-show="item.ArchivoFactura!=null" @click="AbrirDocumento(RutaPdfDepreciacion+item.ArchivoFactura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
								<button v-show="item.ArchivoFactura==null" @click="AbrirDocumento(RutaPdfCuenta+item.Factura)" class="btn-icon mr-2" title="Ver Documentación"><i class="fa fa-file-pdf"></i></button>
                            </template>
                        </Cbtnaccion>
                    </td>
                    <td ></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoDepreciacion.length" :pColspan="7"></CSinRegistros>
			</template>
			<template v-if="Botones.Stock" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Refacción</th>
					<th>Cantidad</th>
					<th>Valor</th>
					<th>Fecha de Revisión</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoStock()" type="button" data-toggle="modal" data-target="#Stock" class="btn-obs"><i class="fa fa-plus" title="Agregar Stock"></i></button>
                    </th>
				</tr>
			</template>
			<template slot="body" v-if="Botones.Stock">
				<tr v-for="(item,index) in ListStock" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.Fecha,false)}}</td>
					<td>{{item.Item+' '+item.Marca+' '+item.Modelo}}</td>
					<td>{{item.Cantidad}}</td>
					<td>{{item.Valor}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaRevision,false)}}</td>
					<td>{{item.Observaciones}}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalStock.EmitSeccion" 
                        :Id="item.IdVehiculoStock"
                        :IrA="ConfigModalStock.Nombre">
                        </Cbtnaccion>
                    </td>
					<td></td>
				</tr>
			</template>
			<template v-if="Botones.Observacion" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
                        <button @click="NuevoObservacion()" type="button" data-toggle="modal" data-target="#Observacion" class="btn-obs"><i class="fa fa-plus" title="Agregar Observación"></i></button>
                    </th>
				</tr>
			</template>
			<template slot="body" v-if="Botones.Observacion">
				<tr v-for="(item,index) in ListVehiculoObservacion" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaReg,false)}}</td>
					<td>{{item.Observaciones}}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalObservacion.EmitSeccion" 
                        :Id="item.IdVehiculoObservacion"
                        :IrA="ConfigModalStock.Nombre">
                        </Cbtnaccion>
                    </td>
					<td></td>
				</tr>
				<CSinRegistros :pContIF="ListVehiculoHerramienta.length" :pColspan="4"></CSinRegistros>
			</template>
		</Clist>
			</template>
		</CLoader>
		
		<Modal :size="ConfigModalVehiculo.Size" :Nombre="ConfigModalVehiculo.Nombre" :poBtnSave="ConfigModalVehiculo">
			<template slot="Form">
				<Vehiculo :poBtnSave="oBtnSaveVehiculo"></Vehiculo>
			</template>
		</Modal>
		<Modal :pEmitSeccion="ConfigModalCombustible.EmitSeccion" :NameModal="ConfigModalCombustible.NombreSeccion"  :size="ConfigModalCombustible.Size" :Nombre="'Combustible'" :poBtnSave="oBtnSaveCombustible">
            <template slot="Form">
                <Combustible :NameList="ConfigModalCombustible.NameForm" :poBtnSave="oBtnSaveCombustible">
                </Combustible>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalSeguro.EmitSeccion" :NameModal="ConfigModalSeguro.NombreSeccion"  :size="ConfigModalSeguro.Size" :Nombre="'Seguro'" :poBtnSave="oBtnSaveSeguro">
            <template slot="Form">
                <Seguro :NameList="ConfigModalSeguro.NameForm" :poBtnSave="oBtnSaveSeguro">
                </Seguro>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalSiniestro.EmitSeccion" :NameModal="ConfigModalSiniestro.NombreSeccion"  :size="ConfigModalSiniestro.Size" :Nombre="'Reporte de Siniestro'" :poBtnSave="oBtnSaveSiniestro">
            <template slot="Form">
                <Siniestro :NameList="ConfigModalSiniestro.NameForm" :poBtnSave="oBtnSaveSiniestro">
                </Siniestro>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalRefaccion.EmitSeccion" :NameModal="ConfigModalRefaccion.NombreSeccion"  :size="ConfigModalRefaccion.Size" :Nombre="'Refacciones'" :poBtnSave="oBtnSaveRefaccion">
            <template slot="Form">
                <Refaccion :NameList="ConfigModalRefaccion.NameForm" :poBtnSave="oBtnSaveRefaccion">
                </Refaccion>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalReparacion.EmitSeccion" :NameModal="ConfigModalReparacion.NombreSeccion"  :size="ConfigModalReparacion.Size" :Nombre="'Reparaciones'" :poBtnSave="oBtnSaveReparacion">
            <template slot="Form">
                <Reparacion :NameList="ConfigModalReparacion.NameForm" :poBtnSave="oBtnSaveReparacion">
                </Reparacion>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalKilometraje.EmitSeccion" :NameModal="ConfigModalKilometraje.NombreSeccion"  :size="ConfigModalKilometraje.Size" :Nombre="'Odómetro'" :poBtnSave="oBtnSaveKilometraje">
            <template slot="Form">
                <Kilometraje :NameList="ConfigModalKilometraje.NameForm" :poBtnSave="oBtnSaveKilometraje" :pListKilometraje="ListVehiculoKilometraje">
                </Kilometraje>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalMantenimiento.EmitSeccion" :NameModal="ConfigModalMantenimiento.NombreSeccion"  :size="ConfigModalMantenimiento.Size" :Nombre="'Mantenimiento'" :poBtnSave="oBtnSaveMantenimiento">
            <template slot="Form">
                <Mantenimiento :NameList="ConfigModalMantenimiento.NameForm" :poBtnSave="oBtnSaveMantenimiento">
                </Mantenimiento>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalHerramienta.EmitSeccion" :NameModal="ConfigModalHerramienta.NombreSeccion"  :size="ConfigModalHerramienta.Size" :Nombre="'Herramienta'" :poBtnSave="oBtnSaveHerramienta">
            <template slot="Form">
                <Herramienta :NameList="ConfigModalHerramienta.NameForm" :poBtnSave="oBtnSaveHerramienta">
                </Herramienta>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalPermiso.EmitSeccion" :NameModal="ConfigModalPermiso.NombreSeccion"  :size="ConfigModalPermiso.Size" :Nombre="'Permisos Y Licencias'" :poBtnSave="oBtnSavePermiso">
            <template slot="Form">
                <Permiso :NameList="ConfigModalPermiso.NameForm" :poBtnSave="oBtnSavePermiso">
                </Permiso>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalDepreciacion.EmitSeccion" :NameModal="ConfigModalDepreciacion.NombreSeccion"  :size="ConfigModalDepreciacion.Size" :Nombre="'Depreciacion Y Leasing'" :poBtnSave="oBtnSaveDepreciacion">
            <template slot="Form">
                <Depreciacion :NameList="ConfigModalDepreciacion.NameForm" :poBtnSave="oBtnSaveDepreciacion">
                </Depreciacion>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalStock.EmitSeccion" :NameModal="ConfigModalStock.NombreSeccion"  :size="ConfigModalStock.Size" :Nombre="'Stock'" :poBtnSave="oBtnSaveStock">
            <template slot="Form">
                <Stock :NameList="ConfigModalStock.NameForm" :poBtnSave="oBtnSaveStock">
                </Stock>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalObservacion.EmitSeccion" :NameModal="ConfigModalObservacion.NombreSeccion"  :size="ConfigModalObservacion.Size" :Nombre="'Observacion'" :poBtnSave="oBtnSaveObservacion">
            <template slot="Form">
                <Observacion :NameList="ConfigModalObservacion.NameForm" :poBtnSave="oBtnSaveObservacion">
                </Observacion>
            </template>
        </Modal>
	</div>
</template>

<script>
import $$ from "jquery";
import Config from "@/helpers/VarConfig.js";
import Modal from '@/components/Cmodal.vue';
import Clist from "@/components/Clist.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import CSinRegistros from "@/components/CSinRegistros";
import Vehiculo from "@/views/catalogos/vehiculo/Form.vue";
import Combustible from "./forms/Combustible.vue";
import Seguro from "./forms/Seguro.vue";
import Siniestro from "./forms/Siniestro.vue";
import Refaccion from "./forms/Refaccion.vue";
import Reparacion from "./forms/Reparacion.vue";
import Kilometraje from "./forms/Kilometraje.vue";
import Mantenimiento from "./forms/Mantenimiento.vue";
import Herramienta from "./forms/Herramienta.vue";
import Permiso from "./forms/Permiso.vue";
import Depreciacion from "./forms/Depreciacion.vue";
import Stock from "./forms/Stock.vue";
import Observacion from "./forms/Observacion.vue";
import CLoader from "@/components/CLoader";
export default {
	components:{
		CLoader,
		Modal,
        Clist,
        Cbtnaccion,
        CSinRegistros,
		Vehiculo,
		Combustible,
		Seguro,
		Siniestro,
		Refaccion,
		Kilometraje,
		Mantenimiento,
		Herramienta,
		Permiso,
		Reparacion,
		Depreciacion,
		Stock,
		Observacion
	},
	props:["Id","pOrigen"],
	data() {
		return {
			Titulo:"Vehículos",
			Regresar:true,
            EsModal:true,
			Filtro:{
                Nombre: "",
				Placeholder: "Nombre..",
				TotalItem: 0,
				Pagina: 1,
				Entrada: 8,
				Show:true,
                rangeDate:{
                    start:null,
                    end:null
                },
                Estatus:''
            },
			ListaAnios:[],
			Anio:'',
			Mes:'',
			ShowFiltroVehiculo:false,
			ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			ConfigLoadGral:{
                ShowLoader:true,
                ClassLoad:true
            },
			ShowPager:true,
			ConfigModalVehiculo:{
                NombreSeccion:"Vehiculo",
                // EmitSeccion:"Trabajador",
                Size:"modal-lg",
                Nombre:"Vehiculo",
                NameForm:"Vehiculo"
            },
			oBtnSaveVehiculo:{
                isModal:true,
                disableBtn:false,
                toast:0,
                // nombreModal:"Trabajador",
                // EmitSeccion:"Trabajador"
            },
			ConfigModalCombustible:{
                NombreSeccion:"Combustible",
                EmitSeccion:"Combustible",
                Size:"modal-lg",
                Nombre:"Combustible",
                NameForm:"Combustible"
            },
            oBtnSaveCombustible:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Combustible",
                EmitSeccion:"Combustible"
            },
			ConfigModalSeguro:{
                NombreSeccion:"Seguro",
                EmitSeccion:"Seguro",
                Size:"modal-lg",
                Nombre:"Seguro",
                NameForm:"Seguro"
            },
            oBtnSaveSeguro:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Seguro",
                EmitSeccion:"Seguro"
            },
			ConfigModalPermiso:{
                NombreSeccion:"Permiso",
                EmitSeccion:"Permiso",
                Size:"modal-lg",
                Nombre:"Permiso",
                NameForm:"Permiso"
            },
            oBtnSavePermiso:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Permiso",
                EmitSeccion:"Permiso"
            },
			ConfigModalSiniestro:{
                NombreSeccion:"Siniestro",
                EmitSeccion:"Siniestro",
                Size:"modal-md",
                Nombre:"Siniestro",
                NameForm:"Siniestro"
            },
            oBtnSaveSiniestro:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Siniestro",
                EmitSeccion:"Siniestro"
            },
			ConfigModalRefaccion:{
                NombreSeccion:"Refaccion",
                EmitSeccion:"Refaccion",
                Size:"modal-lg",
                Nombre:"Refaccion",
                NameForm:"Refaccion"
            },
            oBtnSaveRefaccion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Refaccion",
                EmitSeccion:"Refaccion"
            },
			ConfigModalReparacion:{
                NombreSeccion:"Reparacion",
                EmitSeccion:"Reparacion",
                Size:"modal-lg",
                Nombre:"Reparacion",
                NameForm:"Reparacion"
            },
            oBtnSaveReparacion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Reparacion",
                EmitSeccion:"Reparacion"
            },
			ConfigModalKilometraje:{
                NombreSeccion:"Kilometraje",
                EmitSeccion:"Kilometraje",
                Size:"modal-md",
                Nombre:"Kilometraje",
                NameForm:"Kilometraje"
            },
            oBtnSaveKilometraje:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Kilometraje",
                EmitSeccion:"Kilometraje"
            },
			ConfigModalMantenimiento:{
                NombreSeccion:"Mantenimiento",
                EmitSeccion:"Mantenimiento",
                Size:"modal-lg",
                Nombre:"Mantenimiento",
                NameForm:"Mantenimiento"
            },
            oBtnSaveMantenimiento:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Mantenimiento",
                EmitSeccion:"Mantenimiento"
            },
			ConfigModalHerramienta:{
                NombreSeccion:"Herramienta",
                EmitSeccion:"Herramienta",
                Size:"modal-md",
                Nombre:"Herramienta",
                NameForm:"Herramienta"
            },
            oBtnSaveHerramienta:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Herramienta",
                EmitSeccion:"Herramienta"
            },
			ConfigModalDepreciacion:{
                NombreSeccion:"Depreciacion",
                EmitSeccion:"Depreciacion",
                Size:"modal-lg",
                Nombre:"Depreciacion",
                NameForm:"Depreciacion"
            },
            oBtnSaveDepreciacion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Depreciacion",
                EmitSeccion:"Depreciacion"
            },
			ConfigModalStock:{
                NombreSeccion:"Stock",
                EmitSeccion:"Stock",
                Size:"modal-lg",
                Nombre:"Stock",
                NameForm:"Stock"
            },
            oBtnSaveStock:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Stock",
                EmitSeccion:"Stock"
            },
			ConfigModalObservacion:{
                NombreSeccion:"Observacion",
                EmitSeccion:"Observacion",
                Nombre:"Observacion",
                NameForm:"Observacion"
            },
            oBtnSaveObservacion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Observacion",
                EmitSeccion:"Observacion"
            },
			RutaImagen:"",
            ValidElement:Config.validImage2m,
			BndImagenVehiculo:0,
            ContadorImagenVehiculo:0,
			ObjImagenVehiculo:{},
			Vehiculo:{
                IdVehiculo:'',
                Categoria:'',
                Marca:'',
                Modelo:'',
                Ano:'',
                Placa:'',
                Numero:'',
                TipoVehiculo:'',
                CostoAnual:0,
                IdSucursal:0,
                IdCategoria:'',
                Inventario:'',
                Historial:'',
                KmRecorridos:0,
                KmProductivos:0,
				KmReales:0,
                Foto:'',
				MantenimientoTotal:0,
				Combustible:0
            },
			Botones:{
                Kilometraje:true,
                Mantenimiento:false,
                Refacciones:false,
                Combustible:false,
                Siniestros:false,
                Seguros:false,
                Herramienta:false,
				Reparacion:false,
				Depreciacion:false,
				Stock:false,
				Permisos:false,
				Observacion:false
            },
			ListVehiculoCombustible:[],
			ListVehiculoSeguro:[],
			ListVehiculoSiniestro:[],
			ListVehiculoRefacciones:[],
			ListVehiculoKilometraje:[],
			ListVehiculoMantenimiento:[],
			ListVehiculoHerramienta:[],
			ListVehiculoPermiso:[],
			ListVehiculoReparaciones:[],
			ListVehiculoDepreciacion:[],
			ListVehiculoObservacion:[],
			ListStock:[],
			RutaPdfCuenta:'',
			RutaPdfDepreciacion:'',
			RutaPdfMantenimiento:'',
			RutaPdfCombustible:'',
			RutaPdfSeguro:'',
			RutaPdfPermiso:'',
			RutaPdfReparacion:'',
			RutaPdfRefaccion:'',
			RutaPdfSiniestro:''
		}
	},
	methods: {
		async Lista(){
			this.Filtro.Show=true;
            this.ShowPager=true;
            this.ConfigLoad.ShowLoader=true;
			if (this.Botones.Kilometraje) {
				this.$http.get('vehiculokilometraje/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoKilometraje=res.data.data.vehiculokilometraje;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Combustible) {
				this.$http.get('vehiculocombustible/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoCombustible=res.data.data.vehiculocombustible;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
					this.RutaPdfCuenta=res.data.rutacuenta;
					this.RutaPdfCombustible=res.data.ruta;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Seguros) {
				this.$http.get('vehiculoseguro/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoSeguro=res.data.data.vehiculoseguro;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
					this.RutaPdfCuenta=res.data.rutacuenta;
					this.RutaPdfSeguro=res.data.ruta;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Siniestros) {
				this.$http.get('vehiculosiniestro/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoSiniestro=res.data.data.vehiculosiniestro;
					this.RutaPdfSiniestro=res.data.ruta;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Reparacion) {
				this.$http.get('vehiculoreparacion/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoReparaciones=res.data.data.vehiculoreparacion;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
					this.RutaPdfCuenta=res.data.rutacuenta;
					this.RutaPdfReparacion=res.data.ruta;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Refacciones) {
				this.$http.get('vehiculorefaccion/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoRefacciones=res.data.data.vehiculorefaccion;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
					this.RutaPdfCuenta=res.data.rutacuenta;
					this.RutaPdfRefaccion=res.data.ruta;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Mantenimiento) {
				this.$http.get('vehiculomantenimiento/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoMantenimiento=res.data.data.vehiculomantenimiento;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
					this.RutaPdfCuenta=res.data.rutacuenta;
					this.RutaPdfMantenimiento=res.data.ruta;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Herramienta) {
				this.$http.get('vehiculoherramienta/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoHerramienta=res.data.data.vehiculoherramienta;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Observacion) {
				this.$http.get('vehiculoobservacion/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoObservacion=res.data.data.vehiculoobservacion;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Permisos) {
				this.$http.get('vehiculopermiso/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoPermiso=res.data.data.vehiculopermiso;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
					this.RutaPdfCuenta=res.data.rutacuenta;
					this.RutaPdfPermiso=res.data.ruta;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Depreciacion) {
				this.$http.get('vehiculodepreciacion/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListVehiculoDepreciacion=res.data.data.vehiculodepreciacion;
					this.RutaPdfCuenta=res.data.rutacuenta;
					this.RutaPdfDepreciacion=res.data.ruta;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
			if (this.Botones.Stock) {
				this.$http.get('vehiculostock/get',{
                    params:{
                        IdVehiculo:this.Vehiculo.IdVehiculo,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
                }).then((res)=>{
                    this.ListStock=res.data.data.vehiculostock;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                }).finally(()=>{
                    this.ConfigLoad.ShowLoader=false;
                })
			}
		},
		async GetAnios(){
			await this.$http.get("funciones/getanios").then(res => {
				//console.log('Calling Years');
				this.ListaAnios = res.data.ListaAnios;
				this.Anio = res.data.AnioActual;
				this.GetVehiculo();
			});
		},
		GetVehiculo(){
			this.$http.get("vehiculo/recoverytarjeta",{
                params:{
                    IdVehiculo: this.Vehiculo.IdVehiculo,
					Anio:this.Anio,
					Mes:this.Mes
                }
            }).then((res)=>{
				this.Vehiculo=res.data.data.vehiculo;
				this.Vehiculo.KmRecorridos=res.data.data.kmrecorridos;
				this.Vehiculo.KmProductivos=res.data.data.kmproductivos;
				this.Vehiculo.KmReales=res.data.data.kmreales;
				this.Vehiculo.MantenimientoTotal=res.data.data.mantenimientototal;
				this.Vehiculo.Combustible=res.data.data.combustible;
				let Foto = res.data.data.vehiculo.Foto;
				if (Foto != "" && Foto != null) {
					this.Vehiculo.Foto = res.data.data.UrlFoto + this.Vehiculo.Foto;
				}
				this.readURL(this.Vehiculo.Foto);
			}).finally(()=>{
				this.ConfigLoadGral.ShowLoader=false;
			})
		},
		readURL(input) {
			$$("#imagePreviewFicha").css("background-image", "url(" + input + ")");
			$$("#imagePreviewFicha").hide();
			$$("#imagePreviewFicha").fadeIn(650);
		},
		CambiarPestania(index){
            let Botones=this.Botones;
			Object.keys(Botones).forEach(function(key,ind){
				if (key==index) {
					Botones[key]=true;
				}
				else{
					Botones[key]=false;
				}
				// console.log(index)
			});
            this.Filtro.Nombre="";
            this.Filtro.Pagina=1;
            this.Lista();
        },
		CambiarImagenVehiculo(target){
            if (this.ContadorImagenVehiculo==0) {
				this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreviewFicha'));
				if(this.$refs.ficha.files[0]!=undefined){
					this.BndImagenVehiculo=1;
					this.ContadorImagenVehiculo++;
					this.ObjImagenVehiculo=this.$refs.ficha.files;
				}
				else{
					this.BndImagenVehiculo=0;
				}
			}
			else{
				this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreviewFicha'));
				if(this.$refs.ficha.files[0]==undefined){
					this.$refs.ficha.files=this.ObjImagenVehiculo;
				}
				else{
					this.ObjImagenVehiculo=this.$refs.ficha.files;
				}
			}
        },
		GuardarImagenVehiculo(){
            // let RutaImagenAnterior=this.Trabajador.Foto2;
            let formData=new FormData();
			let image=this.$refs.ficha.files[0];
			if(image!=undefined){
				if (this.Vehiculo.Foto!=null) {
					let index=this.Vehiculo.Foto.lastIndexOf("/")+1;
					let cadena=this.Vehiculo.Foto.substr(index);	
					formData.set('FotoVehiculoPrevio','/'+cadena);
				}
                formData.set('IdVehiculo',this.Vehiculo.IdVehiculo);
				// formData.set('IdCliente',this.Contacto.IdCliente);
				formData.append('FotoVehiculo',image);
				// this.RutaImagen=image.name;
				// this.$http.post('crmcontactos/imagenexterior/post',formData,{
				// 	'Content-Type':'multipart/form-data'
				// })
                this.$http.post('vehiculo/CambiarImagenVehiculo',formData,{
					'Content-Type':'multipart/form-data'
				})
                .then((res)=>{
                    // this.RutaImagen=RutaImagenAnterior;
					this.$toast.success("Imagen guardada");
					// this.bus.$emit('ActualizarImagenExterior',res.data.data.equipos.ImagenExterior);
					this.BndImagenVehiculo=0;
                    this.ContadorImagenVehiculo=0;
                    
				}).finally(() => {
                    this.GetVehiculo();
                });
			}
			else{
				this.$toast.info("Tienes que subir una imagen");
			}
        },
		EditarVehiculo(Index){
            this.bus.$emit("Nuevo",null,Index);
        },
		BorrarVehiculo(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                     this.$http.delete(
                        'vehiculo/' + Id
                    ).then( (res) => {
                        this.$toast.success('Información eliminada');
						this.bus.$emit("Regresar");
                        // this.Lista();
                    });
                }
            });
        },
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
		EvalMes(Mes){
			let CadenaMes='';
			switch (parseInt(Mes)) {
				case 1:
					CadenaMes='Enero';
					break;
				case 2:
					CadenaMes='Febrero';
					break;
				case 3:
					CadenaMes='Marzo';
					break;
				case 4:
					CadenaMes='Abril';
					break;
				case 5:
					CadenaMes='Mayo';
					break;
				case 6:
					CadenaMes='Junio';
					break;
				case 7:
					CadenaMes='Julio';
					break;
				case 8:
					CadenaMes='Agosto';
					break;
				case 9:
					CadenaMes='Septiembre';
					break;
				case 10:
					CadenaMes='Octubre';
					break;
				case 11:
					CadenaMes='Noviembre';
					break;
				case 12:
					CadenaMes='Diciembre';
					break;
			}
			return CadenaMes;
		},
		EliminarCombustible(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculocombustible/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarSeguro(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculoseguro/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarSiniestro(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculosiniestro/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarRefaccion(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculorefaccion/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarReparacion(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculoreparacion/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarKilometraje(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculokilometraje/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('List');
						this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarMantenimiento(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculomantenimiento/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarHerramienta(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculoherramienta/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarPermiso(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculopermiso/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarDepreciacion(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculodepreciacion/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarStock(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculostock/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		EliminarObservacion(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'vehiculoobservacion/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                        // this.ListaTodasPropiedades();
                    })
                }
            })
        },
		NuevoCombustible(){
			this.bus.$emit('NewModal_'+this.ConfigModalCombustible.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoSeguro(){
			this.bus.$emit('NewModal_'+this.ConfigModalSeguro.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoSiniestro(){
			this.bus.$emit('NewModal_'+this.ConfigModalSiniestro.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoMantenimiento(){
			this.bus.$emit('NewModal_'+this.ConfigModalMantenimiento.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoRefaccion(){
			this.bus.$emit('NewModal_'+this.ConfigModalRefaccion.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoReparacion(){
			this.bus.$emit('NewModal_'+this.ConfigModalReparacion.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoKilometraje(){
			this.bus.$emit('NewModal_'+this.ConfigModalKilometraje.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoHerramienta(){
			this.bus.$emit('NewModal_'+this.ConfigModalHerramienta.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoPermiso(){
			this.bus.$emit('NewModal_'+this.ConfigModalPermiso.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoDepreciacion(){
			this.bus.$emit('NewModal_'+this.ConfigModalDepreciacion.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoStock(){
			this.bus.$emit('NewModal_'+this.ConfigModalStock.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		NuevoObservacion(){
			this.bus.$emit('NewModal_'+this.ConfigModalObservacion.EmitSeccion,true,0,this.Vehiculo.IdVehiculo);
		},
		AbrirDocumento(Nombre){
            let archivo = Nombre;
			window.open(
				archivo,
				"_blank",
				"toolbar=1, scrollbars=1, resizable=1, width=" +
					1015 +
					", height=" +
					800
			);
        },
		EvalSiniestroSeguro(Tipo){
			let Cadena='';
			switch (Tipo) {
				case '1':
					Cadena='Sin Seguro';
					break;
				case '2':
					Cadena='Con Seguro';
					break;
				case '3':
					Cadena='Seguro Terceros';
					break;
			}
			return Cadena;
		}
	},
	created() {
		var date = new Date(),
			y = date.getFullYear(),
			m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		this.Filtro.rangeDate = {
			start: firstDay,
			end: lastDay
		};
		this.Vehiculo.IdVehiculo=this.Id;
        this.GetAnios();
        this.Lista();
		this.bus.$off('List');
        this.bus.$on('List',()=>{
            this.GetVehiculo();
        });
        this.bus.$off('ListaPrincipal');
        this.bus.$on('ListaPrincipal',()=>{
            this.Lista();
        });
		this.bus.$on('Regresar',()=> 
        {
			if (this.pOrigen=='Lista') {
				this.$router.push({name:'vehiculo'});	
			}
			else{
				this.$router.push({name:'flotilla'});
			}
        });
		this.bus.$off('Delete_'+this.ConfigModalCombustible.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalCombustible.EmitSeccion,(Id)=>{
            this.EliminarCombustible(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalSeguro.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalSeguro.EmitSeccion,(Id)=>{
            this.EliminarSeguro(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalSiniestro.EmitSeccion);
		this.bus.$on('Delete_'+this.ConfigModalSiniestro.EmitSeccion,(Id)=>{
            this.EliminarSiniestro(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalRefaccion.EmitSeccion);
		this.bus.$on('Delete_'+this.ConfigModalRefaccion.EmitSeccion,(Id)=>{
            this.EliminarRefaccion(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalReparacion.EmitSeccion);
		this.bus.$on('Delete_'+this.ConfigModalReparacion.EmitSeccion,(Id)=>{
            this.EliminarReparacion(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalKilometraje.EmitSeccion);
		this.bus.$on('Delete_'+this.ConfigModalKilometraje.EmitSeccion,(Id)=>{
            this.EliminarKilometraje(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalMantenimiento.EmitSeccion);
		this.bus.$on('Delete_'+this.ConfigModalMantenimiento.EmitSeccion,(Id)=>{
            this.EliminarMantenimiento(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalHerramienta.EmitSeccion);
		this.bus.$on('Delete_'+this.ConfigModalHerramienta.EmitSeccion,(Id)=>{
            this.EliminarHerramienta(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalPermiso.EmitSeccion);
		this.bus.$on('Delete_'+this.ConfigModalPermiso.EmitSeccion,(Id)=>{
            this.EliminarPermiso(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalDepreciacion.EmitSeccion);
		this.bus.$on('Delete_'+this.ConfigModalDepreciacion.EmitSeccion,(Id)=>{
            this.EliminarDepreciacion(Id);
        });
	},
}
</script>

<style>

</style>
